"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _lodash = require("lodash");
var _styles = require("@material-ui/core/styles");
var _Core = require("@Core");
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));
var _checkbox = _interopRequireDefault(require("./checkbox"));
var _email = _interopRequireDefault(require("./email"));
var _formbutton = _interopRequireDefault(require("./formbutton"));
var _formdate = _interopRequireDefault(require("./formdate"));
var _formheadline = _interopRequireDefault(require("./formheadline"));
var _formtext = _interopRequireDefault(require("./formtext"));
var _input = _interopRequireDefault(require("./input"));
var _select = _interopRequireDefault(require("./select"));
var _textarea = _interopRequireDefault(require("./textarea"));
var _upload = _interopRequireDefault(require("./upload"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(() => ({
  form: {
    userSelect: "none"
  }
}));
const Form = props => {
  const {
    id: formID,
    elements
  } = props.data;
  const [message, setMessage] = (0, _react.useState)();
  const {
    i18n,
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  if (!(0, _lodash.isArray)(elements)) {
    return null;
  }
  const handleSubmit = e => {
    e.preventDefault();
    const {
      REACT_APP_PATH
    } = process.env;
    const url = REACT_APP_PATH + "/submitform.json.api";
    const data = new FormData(e.target);
    fetch(url, {
      method: "POST",
      body: data
    }).then(response => response.json()).then(data => {
      const {
        state,
        redirect
      } = data || {};
      if (state === 0) {
        if (redirect) {
          window.location.href = redirect;
          return;
        }
        setMessage({
          type: "success",
          text: t("site.ui.messages.formSuccess")
        });
      } else {
        setMessage({
          type: "error",
          text: t("site.ui.messages.formError")
        });
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit,
    className: css.form
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "_ProcessForm",
    value: formID
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "_Language",
    value: i18n.language
  }), /*#__PURE__*/_react.default.createElement(FormElements, {
    elements: elements,
    lang: i18n.language
  }), message && /*#__PURE__*/_react.default.createElement(_Box.default, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    severity: message === null || message === void 0 ? void 0 : message.type
  }, message === null || message === void 0 ? void 0 : message.text)));
};
const FormElements = props => {
  const {
    elements,
    lang
  } = props;
  const [userData] = (0, _react.useContext)(_Core.UserContext);
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  let hasSubmitButton = false;
  const fields = elements.map(formItem => {
    var _userData$text, _userData$text2, _userData$text3;
    const {
      id,
      title,
      text,
      addition,
      option,
      option2,
      option3: countryList,
      additioncontent
    } = formItem || {};
    switch (formItem.tag) {
      case "basic-form-headline":
        return /*#__PURE__*/_react.default.createElement(_Grid.default, {
          item: true,
          key: id,
          xs: 12
        }, /*#__PURE__*/_react.default.createElement(_formheadline.default, {
          title: formItem.title
        }));
      case "basic-form-input":
        return /*#__PURE__*/_react.default.createElement(_Grid.default, {
          item: true,
          key: id,
          xs: 12,
          sm: 6
        }, /*#__PURE__*/_react.default.createElement(_input.default, {
          defaultValue: (_userData$text = userData === null || userData === void 0 ? void 0 : userData[text]) !== null && _userData$text !== void 0 ? _userData$text : "",
          label: title,
          name: text,
          placeholder: addition,
          required: option === 1 ? true : false
        }));
      case "basic-form-mail":
        return /*#__PURE__*/_react.default.createElement(_Grid.default, {
          item: true,
          key: id,
          xs: 12,
          sm: 6
        }, /*#__PURE__*/_react.default.createElement(_email.default, {
          defaultValue: (_userData$text2 = userData === null || userData === void 0 ? void 0 : userData[text]) !== null && _userData$text2 !== void 0 ? _userData$text2 : "",
          label: title,
          name: text,
          placeholder: addition,
          required: option === 1 || 2 ? true : false
        }));
      case "basic-form-select":
        const {
          items
        } = additioncontent || {};
        return /*#__PURE__*/_react.default.createElement(_Grid.default, {
          item: true,
          key: id,
          xs: 12,
          sm: 6
        }, /*#__PURE__*/_react.default.createElement(_select.default, {
          countryList: countryList === 1 ? true : false,
          defaultValue: (_userData$text3 = userData === null || userData === void 0 ? void 0 : userData[text]) !== null && _userData$text3 !== void 0 ? _userData$text3 : "",
          label: title,
          lang: lang,
          name: text,
          required: option === 1 ? true : false,
          options: items
        }));
      case "basic-form-checkbox":
        return /*#__PURE__*/_react.default.createElement(_Grid.default, {
          item: true,
          key: id,
          xs: 12
        }, /*#__PURE__*/_react.default.createElement(_checkbox.default, {
          label: title,
          name: text,
          value: addition,
          addition: addition,
          required: option === 1 ? true : false,
          checked: option2 === 1 ? true : false
        }));
      case "basic-form-textarea":
        return /*#__PURE__*/_react.default.createElement(_Grid.default, {
          item: true,
          key: id,
          xs: 12
        }, /*#__PURE__*/_react.default.createElement(_textarea.default, {
          label: title,
          name: text,
          placeholder: addition,
          required: option === 1 ? true : false
        }));
      case "basic-form-infotext":
        return /*#__PURE__*/_react.default.createElement(_Grid.default, {
          item: true,
          key: id,
          xs: 12
        }, /*#__PURE__*/_react.default.createElement(_formtext.default, {
          title: formItem.addition
        }));
      case "basic-form-button":
        hasSubmitButton = true;
        return /*#__PURE__*/_react.default.createElement(_Grid.default, {
          item: true,
          key: id,
          xs: 12
        }, /*#__PURE__*/_react.default.createElement(_formbutton.default, {
          title: formItem.title
        }));
      case "basic-form-date":
        return /*#__PURE__*/_react.default.createElement(_Grid.default, {
          item: true,
          key: id,
          xs: 12,
          sm: 6
        }, /*#__PURE__*/_react.default.createElement(_formdate.default, {
          defaultValue: addition,
          label: title,
          name: text,
          required: option === 1 ? true : false
        }));
      case "basic-form-upload":
        return /*#__PURE__*/_react.default.createElement(_Grid.default, {
          item: true,
          key: id,
          xs: 12,
          sm: 6
        }, /*#__PURE__*/_react.default.createElement(_upload.default, {
          label: title,
          name: text,
          required: option === 4 ? true : false,
          addition: addition
        }));
      default:
        console.info("form field missing", formItem);
        return null;
    }
  });

  // add fixed form button

  if (!hasSubmitButton) {
    fields.push( /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      key: "fixed-form-button",
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_formbutton.default, {
      title: i18n.language === "de" ? "Senden" : "Send"
    })));
  }
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 3
  }, fields);
};
var _default = exports.default = Form;